import type { TTicketingEscalationField } from '@cascade/api-client/shared';
import { isTextLengthWithin } from '@cascade/core/utils';
import type { TTicketFieldValue } from './TicketField.types.ts';

export const isOverLength = (
  field: TTicketingEscalationField,
  value?: TTicketFieldValue,
): boolean =>
  typeof value === 'string' &&
  !isTextLengthWithin(value, { max: field.max_length });
